var _path, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllocateLicense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 3.33337H2V12.6667H10.5714H14V5.08337V3.33337H9.33333",
    className: "iconStroke",
    strokeWidth: 1.33
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.66667,
    y: 6.66663,
    width: 2.66667,
    height: 2.66667,
    className: "iconStroke"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.66666,
    y: 0.999959,
    width: 0.666667,
    height: 3.33333,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.66666,
    y: 6.33333,
    width: 2,
    height: 0.666667,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.66666,
    y: 8.99996,
    width: 1.33333,
    height: 0.666667,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocateLicense);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNjY2NjcgMy4zMzMzN0gyVjEyLjY2NjdIMTAuNTcxNEgxNFY1LjA4MzM3VjMuMzMzMzdIOS4zMzMzMyIgY2xhc3M9Imljb25TdHJva2UiIHN0cm9rZS13aWR0aD0iMS4zMyIvPgo8cmVjdCB4PSI0LjY2NjY3IiB5PSI2LjY2NjYzIiB3aWR0aD0iMi42NjY2NyIgaGVpZ2h0PSIyLjY2NjY3IiBjbGFzcz0iaWNvblN0cm9rZSIgLz4KPHJlY3QgeD0iNy42NjY2NiIgeT0iMC45OTk5NTkiIHdpZHRoPSIwLjY2NjY2NyIgaGVpZ2h0PSIzLjMzMzMzIiBjbGFzcz0iaWNvblN0cm9rZUFuZEZpbGwiIHN0cm9rZS13aWR0aD0iMC42NjY2NjciLz4KPHJlY3QgeD0iOS42NjY2NiIgeT0iNi4zMzMzMyIgd2lkdGg9IjIiIGhlaWdodD0iMC42NjY2NjciIGNsYXNzPSJpY29uU3Ryb2tlQW5kRmlsbCIgc3Ryb2tlLXdpZHRoPSIwLjY2NjY2NyIvPgo8cmVjdCB4PSI5LjY2NjY2IiB5PSI4Ljk5OTk2IiB3aWR0aD0iMS4zMzMzMyIgaGVpZ2h0PSIwLjY2NjY2NyIgY2xhc3M9Imljb25TdHJva2VBbmRGaWxsIiBzdHJva2Utd2lkdGg9IjAuNjY2NjY3Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };